export default "__VITE_ASSET__nZl4OqOC__"